import { ThemeColorMode } from 'src/common/enums';
import type { RouteHandleObject } from 'src/common/interfaces';

export const rootHandle: Partial<RouteHandleObject> = {
  forcedTheme: ThemeColorMode.DARK,
};

export const withoutFooter: Partial<RouteHandleObject> = {
  ...rootHandle,
  hideFooter: true,
};

export const fullScreen: Partial<RouteHandleObject> = {
  ...withoutFooter,
  headerDisplayNone: true,
};
